import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Gates admin-only routes.
 * - Not authed  → redirect to /login
 * - Authed but not admin → redirect to /  with an access-denied flag
 * - Loading → branded spinner
 */
export default function AdminOnlyRoute({ children }) {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-cool-white grid place-items-center">
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 rounded-full border-2 border-cyan-brand border-t-transparent animate-spin" />
          <div className="text-sm text-cool-grey font-mono-data">Verifying access…</div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace state={{ accessDenied: true }} />;
  }

  return children;
}
